/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type DataClassificationsSettingsType from '@jira/spa-apps__project-settings-data-classifications/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyDataClassificationsSettings: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof DataClassificationsSettingsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-data-classifications", jiraSpaEntry: "async-project-settings-data-classifications" */ '@jira/spa-apps__project-settings-data-classifications/src/index.tsx'
			),
		),
	);

const AsyncDataClassificationsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDataClassificationsSettings}
		pageId="project-settings-data-classifications"
		shouldShowSpinner={false}
	/>
);

export default AsyncDataClassificationsSettings;
